<div class="dpf">
  <f-flow class="dpf-flow" fDraggable (fLoaded)="onFlowLoaded()">
    <f-background>
      <f-circle-pattern></f-circle-pattern>
    </f-background>

    <f-canvas fZoom>
      <!-- nodos de acción -->
      <div *ngFor="let node of actionNodes; trackBy: trackNode"
           fNode
           [fNodeId]="node.id"
           [fNodePosition]="{ x: node.x, y: node.y }"
           [fNodeDraggingDisabled]="true"
           [fNodeSize]="{ width: node.width, height: node.height }"
           class="dpf-node">
        <ng-container *ngIf="node.action; else startTpl">
          <div fNodeInput [fInputId]="node.id + '-in'" class="dpf-input"></div>
          <div class="dpf-card"
               [class.dpf-card-moving]="movingAction === node.action"
               [class.dpf-card-link-target]="isLinkTarget(node)"
               (click)="editAction(node)">
            <span class="dpf-icon" [style.background]="styleFor(node.action).color">
              <i [class]="styleFor(node.action).icon"></i>
            </span>
            <span class="dpf-text">
              <span class="dpf-title">{{styleFor(node.action).label}}</span>
              <span class="dpf-subtitle">{{subtitleFor(node.action)}}</span>
            </span>
            <span class="dpf-chevron">
              <i class="pi pi-chevron-down"></i>
            </span>
          </div>
          <button *ngIf="!movingAction && !linkingFrom" class="dpf-move" type="button" fDragBlocker
                  (click)="startMove(node.action)"
                  pTooltip="Mover" tooltipPosition="top">
            <i class="pi pi-arrows-alt"></i>
          </button>
          <button *ngIf="!movingAction && !linkingFrom" class="dpf-delete" type="button" fDragBlocker
                  (click)="deleteAction(node.action)"
                  pTooltip="Eliminar" tooltipPosition="top">
            <i class="pi pi-times"></i>
          </button>
          <div fNodeOutput [fOutputId]="node.id + '-out'" class="dpf-output"></div>
        </ng-container>
        <ng-template #startTpl>
          <div class="dpf-card dpf-card-start">
            <span class="dpf-icon" [style.background]="styleFor(null).color">
              <i [class]="styleFor(null).icon"></i>
            </span>
            <span class="dpf-text">
              <span class="dpf-title">{{styleFor(null).label}}</span>
              <span class="dpf-subtitle">{{subtitleFor(null)}}</span>
            </span>
          </div>
          <div fNodeOutput [fOutputId]="node.id + '-out'" class="dpf-output"></div>
        </ng-template>
      </div>

      <!-- mini-nodos de rama -->
      <div *ngFor="let node of branchNodes; trackBy: trackNode"
           fNode
           [fNodeId]="node.id"
           [fNodePosition]="{ x: node.x, y: node.y }"
           [fNodeDraggingDisabled]="true"
           [fNodeSize]="{ width: node.width, height: node.height }"
           class="dpf-node">
        <div fNodeInput [fInputId]="node.id + '-in'" class="dpf-input"></div>
        <div class="dpf-branch-card">
          <span class="dpf-branch-label">{{branchLabelFor(node)}}</span>
        </div>
        <button class="dpf-delete dpf-delete-branch" type="button" fDragBlocker
                (click)="deleteBranch(node.branch)"
                pTooltip="Eliminar rama" tooltipPosition="top">
          <i class="pi pi-times"></i>
        </button>
        <div fNodeOutput [fOutputId]="node.id + '-out'" class="dpf-output"></div>
      </div>

      <!-- slots "+" para añadir acción -->
      <div *ngFor="let node of addNodes; trackBy: trackNode"
           fNode
           [fNodeId]="node.id"
           [fNodePosition]="{ x: node.x, y: node.y }"
           [fNodeSize]="{ width: node.width, height: node.height }"
           [fNodeDraggingDisabled]="true"
           class="dpf-node">
        <div fNodeInput [fInputId]="node.id + '-in'" class="dpf-input dpf-input-hidden"></div>
        <button class="dpf-add" type="button"
                [class.dpf-add-target]="movingAction && isMoveTargetSlot(node)"
                [class.dpf-slot-disabled]="(movingAction && !isMoveTargetSlot(node)) || linkingFrom"
                (click)="onSlotClick(node)"
                [pTooltip]="movingAction ? 'Mover aquí' : 'Añadir acción'" tooltipPosition="top">
          <i [class]="movingAction ? 'pi pi-sign-in' : 'pi pi-plus'"></i>
        </button>
      </div>

      <!-- slots para añadir rama -->
      <div *ngFor="let node of addBranchNodes; trackBy: trackNode"
           fNode
           [fNodeId]="node.id"
           [fNodePosition]="{ x: node.x, y: node.y }"
           [fNodeSize]="{ width: node.width, height: node.height }"
           [fNodeDraggingDisabled]="true"
           class="dpf-node">
        <div fNodeInput [fInputId]="node.id + '-in'" class="dpf-input dpf-input-hidden"></div>
        <button class="dpf-add dpf-add-branch" type="button"
                [class.dpf-slot-disabled]="movingAction || linkingFrom"
                (click)="!movingAction && !linkingFrom && startAddBranch(node.parentAction)"
                pTooltip="Añadir rama" tooltipPosition="top">
          <i class="pi pi-share-alt"></i>
        </button>
      </div>

      <f-connection *ngFor="let edge of edges; trackBy: trackEdge"
                    fBehavior="fixed"
                    fType="segment"
                    [fOffset]="24"
                    [class.dpf-connection-link]="edge.isLink"
                    [fOutputId]="edge.source + '-out'"
                    [fInputId]="edge.target + '-in'">
        <f-connection-marker-arrow fMarkerType="end"></f-connection-marker-arrow>
        <button *ngIf="edge.insertAt"
                fConnectionContent [position]="0.5"
                class="dpf-insert-btn"
                [class.dpf-add-target]="movingAction && isMoveTargetEdge(edge)"
                [class.dpf-slot-disabled]="movingAction && !isMoveTargetEdge(edge)"
                type="button"
                (click)="onEdgeInsertClick(edge)"
                [pTooltip]="movingAction ? 'Mover aquí' : 'Insertar acción'" tooltipPosition="right">
          <i [class]="movingAction ? 'pi pi-sign-in' : 'pi pi-plus'"></i>
        </button>
        <button *ngIf="edge.isLink && !movingAction && !linkingFrom"
                fConnectionContent [position]="0.5"
                class="dpf-link-del-btn"
                type="button"
                (click)="deleteLink(edge)"
                pTooltip="Eliminar enlace" tooltipPosition="right">
          <i class="pi pi-times"></i>
        </button>
      </f-connection>
    </f-canvas>

    <f-minimap [fMinSize]="2000"></f-minimap>
  </f-flow>

  <button type="button" class="dpf-fit-btn"
          (click)="fitNow()"
          pTooltip="Encuadrar flujo" tooltipPosition="left">
    <i class="pi pi-arrows-alt"></i>
  </button>

  <div *ngIf="movingAction" class="dpf-branch-picker dpf-move-banner">
    <div class="flex gap-3 align-items-center">
      <span class="dpf-move-banner-text">
        <i class="pi pi-arrows-alt"></i>
        Moviendo <strong>{{styleFor(movingAction).label}}</strong> — elige un destino
      </span>
      <p-button label="Cancelar" severity="secondary" size="small" [text]="true" (click)="cancelMove()"></p-button>
    </div>
  </div>

  <div *ngIf="slotChoice" class="dpf-branch-picker">
    <div class="dpf-branch-picker-title">Añadir en este punto</div>
    <div class="flex gap-2 align-items-center">
      <p-button label="Nueva acción" icon="pi pi-plus" size="small" (click)="chooseNewAction()"></p-button>
      <p-button label="Conectar a existente" icon="pi pi-link" severity="secondary" size="small"
                (click)="chooseConnect()"></p-button>
      <p-button label="Cancelar" severity="secondary" size="small" [text]="true" (click)="cancelSlotChoice()"></p-button>
    </div>
  </div>

  <div *ngIf="linkingFrom" class="dpf-branch-picker dpf-link-banner">
    <div class="flex gap-3 align-items-center">
      <span class="dpf-move-banner-text">
        <i class="pi pi-link"></i>
        Selecciona la acción destino del enlace
      </span>
      <p-button label="Cancelar" severity="secondary" size="small" [text]="true" (click)="cancelLink()"></p-button>
    </div>
  </div>

  <div *ngIf="addingBranchForAction" class="dpf-branch-picker">
    <div class="dpf-branch-picker-title">
      Nueva rama de <strong>{{styleFor(addingBranchForAction).label}}</strong>
    </div>
    <div class="flex gap-2 align-items-center">
      <p-dropdown [options]="branchOptions(addingBranchForAction)" [(ngModel)]="newBranchDigit"
                  optionLabel="label" optionValue="value" appendTo="body" placeholder="..."></p-dropdown>
      <p-button label="Guardar" icon="pi pi-check" size="small" (click)="saveBranch()"></p-button>
      <p-button label="Cancelar" severity="secondary" size="small" [text]="true" (click)="cancelAddBranch()"></p-button>
    </div>
  </div>

  <p-confirmDialog key="dialPlanFlowConfirm" appendTo="body"></p-confirmDialog>
</div>
